export const EMPLOYEE_REQUEST_LIMIT = 20;
export const POSTS_REQUEST_LIMIT = 20;
export const ATTACHMENTS_LIMIT = 20;
export const DOCUMENTS_PAGE_LIMIT = 20;
export const EMPLOYEES_PREVIEW_LIMIT_RESOURCES_PAGE = 8;
export const EMPLOYEES_PREVIEW_LIMIT_WE_PAGE = 7;
export const TASK_MANAGEMENT_LIST_LIMIT = 20;
export const PINNED_POST_PREVIEW_LIMIT = 2;
export const NOTIFICATIONS_LIMIT = 20;
